module.exports = __webpack_public_path__ + "img/c08.8837a89d.png";